/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export const $MatchSignalCreate = {
    properties: {
        eventAuditLogId: {
            type: 'any-of',
            contains: [{
                type: 'string',
                format: 'uuid4',
            }, {
                type: 'null',
            }],
        },
        userText: {
            type: 'string',
            isRequired: true,
        },
        matchId: {
            type: 'number',
            isRequired: true,
        },
    },
} as const;
